import ContactUsContent from "./sections/ContactUsContent/ContactUsContent";
import ContactUsHero from "./sections/ContactUsHero/ContactUsHero";

const ContactUs = () => {
  return (
    <div>
      <ContactUsHero />
      <ContactUsContent />
    </div>
  );
};

export default ContactUs;
